/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable consistent-return */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-irregular-whitespace */

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import AppNumberInput from '../../shared/components/app-number-input/AppNumberInput';
import {
  checkValidMobileNumber,
  DATE_MONTH_YEAR_VIEW_FORMAT,
  PREF_CLASS_OPTIONS,
} from '../../shared/constants/Constants';
import AppButton from '../../shared/components/app-button/AppButton';
import {
  getUserAgentId,
  getValueFromAppConfig,
} from '../../shared/helper-utils/localStorage';
import {
  formatDate,
  formatTimeString,
  getCabinBaggage,
  getConnectingTime,
  getNewDate,
  isEmpty,
  isMobileWidth,
} from '../../shared/helper-utils/appUtils';
import AppRadioInput from '../../shared/components/app-radio-input/AppRadioInput';
import FlightEmailCard from './FlightEmailCard';
import { getUserDetails } from '../../api/profileApi';
import AppLoading from '../../shared/components/app-loading/AppLoading';
import { useAppContext } from '../../saas/AppConfigWrapper';
import AppTextInput from '../../shared/components/app-text-input/AppTextInput';
import AppSelect from '../../shared/components/app-select/AppSelect';
import { countryMobileCodes } from '../../shared/constants/CountryOptions';

const getLabel = (country) => {
  return (
    <div
      className="flex justify-between items-center gap-2"
      title={country.name}
    >
      <div className="flex items-center gap-1 w-[78%]">
        <img
          style={{ width: '17px', height: '15px', display: 'inline' }}
          src={`https://cdn.jsdelivr.net/gh/lipis/flag-icons/flags/4x3/${country.code.toLowerCase()}.svg`}
          alt={country.code}
        />
        <span className="text-[12px] overflow-hidden">{country.name}</span>
      </div>
      <div className="flex-shrink-0">
        <span className="text-[12px]">{country.dial_code}</span>
      </div>
    </div>
  );
};

const mobileCodes = countryMobileCodes.map((country) => ({
  label: `${country.name} ${country.dial_code}`,
  value: country.dial_code,
  country,
}));

function OneWayWhatsAppModal({ searchRequest, selectedForEmail, onSend }) {
  const { appConfig } = useAppContext();
  const [isLoading, setIsLoading] = useState(false);
  const [whatsappNumber, setWhatsappNumber] = useState('');
  const [countryCode, setCountryCode] = useState(appConfig.appMobileCode);
  const [validationError, setValidationError] = useState(false);
  const [showBreakup, setShowBreakup] = useState(true);
  const [markUpToBeAdded, setMarkupToBeAdded] = useState('');
  const [selectedFares, setSelectedFares] = useState(
    selectedForEmail.map((d) => {
      return d.fare.totalfq;
    }),
  );
  const [userDetails, setUserDetails] = useState(null);
  const [countryCodeOptions] = useState(mobileCodes);

  const getAmount = (val) => {
    const markup = markUpToBeAdded === '' ? 0 : parseInt(markUpToBeAdded, 10);
    return parseInt(val, 10) + markup;
  };

  const getUserData = async () => {
    setIsLoading(true);
    const res = await getUserDetails(getUserAgentId());
    if (res?.ApiStatus?.Status === 'OK') {
      const { User } = res.ApiStatus.Result;
      setUserDetails(User);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getUserData();
  }, []);

  const handlesendMessage = () => {
    if (
      whatsappNumber === '' ||
      whatsappNumber === undefined ||
      checkValidMobileNumber(whatsappNumber)
    ) {
      setValidationError(true);
      return false;
    }
    const numberWithCountryCode = (countryCode + whatsappNumber).replace(
      '+',
      '',
    );
    setIsLoading(true);
    let fromEmail = '';
    let contactNum = '';
    let companyName = '';
    if (!isEmpty(userDetails)) {
      fromEmail = userDetails.ContactEmail;
      contactNum = userDetails.ContactNumber;
      companyName = userDetails.Company;
    }
    let msg = '';
    const airplaneEmoji = '✈️';
    selectedForEmail.forEach((flt, fltIndex) => {
      flt.flight.flightlegs.forEach((leg, index) => {
        msg += `${index === 0 ? fltIndex + 1 : ''} ${airplaneEmoji} ${
          leg.validatingcarriername
        } ${leg.carrier.substring(0, 2)} - ${leg.flightnumber} | ${
          leg.origin_name
        } - ${formatDate(
          getNewDate(leg.depdate),
          DATE_MONTH_YEAR_VIEW_FORMAT,
        )} ${formatTimeString(leg.deptime)} --> ${
          leg.destination_name
        } - ${formatDate(
          getNewDate(leg.arrdate),
          DATE_MONTH_YEAR_VIEW_FORMAT,
        )} ${formatTimeString(leg.arrtime)} \n`;
        msg += `Cabin Baggage: 7Kg \nCheckin Baggage: ${getCabinBaggage(
          flt.fare.flightBagWeight[index],
          flt.fare.flightBagUnit[index],
        )} \n`;
        if (
          leg.destination !==
          flt.flight.flightlegs[flt.flight.flightlegs.length - 1].destination
        ) {
          msg += `-------- ${getConnectingTime(
            leg.arrtime,
            leg.arrdate,
            flt.flight.flightlegs[index + 1].deptime,
            flt.flight.flightlegs[index + 1].depdate,
          )} layover in ${leg.destination_name} -------\n`;
        }
      });
      msg += `\nCabin Type : ${PREF_CLASS_OPTIONS[searchRequest.prefclass]}\n`;
      msg += `Stops : ${
        flt.flight.numstops !== 0 ? flt.flight.numstops : 'Non'
      } Stop\n`;
      if (showBreakup) {
        msg += `${flt.fare.faretype} Fare : ${
          appConfig?.appCurrency
        } ${getAmount(selectedFares[fltIndex])}\n`;
      }
      msg += '\n<------------------------------------------>\n\n';
    });
    msg += `👇🏻👇🏻👇🏻👇🏻👇🏻👇🏻👇🏻👇🏻👇🏻👇🏻👇🏻👇🏻👇🏻\n\nThank you for choosing ${companyName}\nIn case of any urgent support : \n`;
    msg += `☎ Contact : ${contactNum}\n✉ Email : ${fromEmail}\n`;
    onSend(numberWithCountryCode, msg);
  };

  const handleAddMarkup = (val) => {
    setMarkupToBeAdded(val);
  };

  return (
    <div>
      <AppLoading isLoading={isLoading} />
      <div>
        <div className="fs-14">
          <div className="d-flex align-items-center gap-3 mb-1">
            <AppRadioInput
              id="true"
              name="showBrakup"
              labelText="With Fare"
              value=""
              onChange={() => setShowBreakup(true)}
              checked={showBreakup}
            />
            <AppRadioInput
              id="false"
              name="showBrakup"
              labelText="Without Fare"
              value=""
              onChange={() => setShowBreakup(false)}
              checked={!showBreakup}
            />
          </div>

          <Row className="mt-3 spacing-8 gapbetween">
            <Col lg={2} md={2} sm={6} xs={12}>
              <AppSelect
                className="country-codes-input"
                name="countryCode"
                id="countryCode"
                label="Country code"
                placeholder=""
                required
                selectedValue={countryCode}
                options={countryCodeOptions}
                formatOptionLabel={(option) => getLabel(option.country)}
                isClearable={false}
                errorText={validationError && 'Please select country code'}
                onSelect={(value) =>
                  value !== null
                    ? setCountryCode(value.value)
                    : setCountryCode('')
                }
              />
            </Col>
            <Col lg={5} md={6} sm={6} xs={12}>
              <AppNumberInput
                name="whatsappNumber"
                label="Enter Mobile Number"
                placeholderText="Enter Customer No"
                value={whatsappNumber}
                required
                onChange={(d) => setWhatsappNumber(d)}
                errorText={validationError && 'Please Enter Mobile Number'}
              />
              {checkValidMobileNumber(whatsappNumber) && validationError && (
                <small className="app-error-text">Enter Valid Number</small>
              )}
            </Col>
            {getValueFromAppConfig('ISCORPORATECLIENT') !== 'true' &&
              getValueFromAppConfig('REQUIRE_MARKUP') !== 'true' &&
              showBreakup && (
                <Col lg={5} md={6} sm={6} xs={12}>
                  <AppNumberInput
                    name="markUpToBeAdded"
                    label={
                      appConfig?.companyName === 'Aman Travels'
                        ? 'Transaction fee'
                        : 'Markup'
                    }
                    value={markUpToBeAdded}
                    onChange={(d) => handleAddMarkup(d)}
                  />
                </Col>
              )}
          </Row>
        </div>
        <div className=" d-flex justify-content-center align-items-center  hide-in-mobile">
          <div
            className="overflow-auto"
            style={{ height: '300px', width: '750px', padding: '1rem' }}
          >
            <div className="border">
              {selectedForEmail.map((selectedFlight, index) => (
                <FlightEmailCard
                  key={selectedFlight.fare.nextraflightkey}
                  flight={selectedFlight.flight}
                  isLast={index === selectedForEmail.length - 1}
                  showHideFare={showBreakup}
                  fare={selectedFlight.fare}
                  markUpToBeAdded={markUpToBeAdded}
                  index={index}
                  searchRequest={searchRequest}
                  isOnward
                  showInput
                  onFareUpdate={() => {}}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-end my-2">
        <AppButton
          variant="primary"
          onClick={handlesendMessage}
          btnText="Share in Whatsapp"
        />
      </div>
    </div>
  );
}

OneWayWhatsAppModal.propTypes = {
  searchRequest: PropTypes.object.isRequired,
  selectedForEmail: PropTypes.array.isRequired,
  onSend: PropTypes.func.isRequired,
};

export default OneWayWhatsAppModal;
